export default __webpack_public_path__ + "static/top-8f83bfd3573b83314339156d99eb200f.jpg";